export const WORKGROUP_LOADING = "WORKGROUP_LOADING";
export const WORKGROUP_RESET = "WORKGROUP_RESET";
export const GET_WORKGROUP = "GET_WORKGROUP";
export const GET_WORKGROUP_SUCCESS = "GET_WORKGROUP_SUCCESS";
export const GET_WORKGROUP_FAIL = "GET_WORKGROUP_FAIL";
export const DELETE_WORKGROUP = "DELETE_WORKGROUP"
export const DELETE_WORKGROUP_SUCCESS = "DELETE_WORKGROUP_SUCCESS"
export const DELETE_WORKGROUP_FAIL = "DELETE_WORKGROUP_FAIL"
export const UPDATE_WORKGROUP = "UPDATE_WORKGROUP"
export const UPDATE_WORKGROUP_SUCCESS = "UPDATE_WORKGROUP_SUCCESS"
export const UPDATE_WORKGROUP_FAIL = "UPDATE_WORKGROUP_FAIL"
export const ADD_NEW_WORKGROUP = "ADD_NEW_WORKGROUP"
export const ADD_WORKGROUP_SUCCESS = "ADD_WORKGROUP_SUCCESS"
export const ADD_WORKGROUP_FAIL = "ADD_WORKGROUP_FAIL"